<template>
  <div class="mt-component-form print-container mb-4">
    <div class="xl:flex content-between items-center">
      <h5 class="w-32"><i class="dot"></i>{{ title }}</h5>
      <div class="flex flex-wrap gap-4 ml-auto" style="justify-content: flex-end">
        <vs-button v-if="!isPrint" color="secondary" type="border" @click="onClickDataDownload"> <feather-icon icon="DownloadIcon" style="width: 20px; height: 20px" class="align-bottom mr-1" />데이터 다운로드</vs-button>
        <vs-button v-if="!isPrint" color="secondary" type="border" @click="onClickExcelUpload(true)"> <feather-icon icon="UploadIcon" style="width: 20px; height: 20px" class="align-bottom mr-1" />데이터 덮어쓰기</vs-button>
        <vs-button
          v-if="!isPrint"
          color="secondary"
          type="border"
          href="https://gnsc.maot.co.kr:8080/storage/app/media/MSDS%20%EB%A6%AC%EC%8A%A4%ED%8A%B8%20%EA%B4%80%EB%A6%AC%20%EC%97%91%EC%85%80%20%EC%97%85%EB%A1%9C%EB%93%9C%20%EC%96%91%EC%8B%9D.xlsx"
        >
          <feather-icon icon="DownloadIcon" style="width: 20px; height: 20px" class="align-bottom mr-1" />엑셀 템플릿 다운로드
        </vs-button>
        <vs-button v-if="!isPrint" color="secondary" type="border" @click="onClickExcelUpload(false)"> <feather-icon icon="UploadIcon" style="width: 20px; height: 20px" class="align-bottom mr-1" />엑셀 템플릿 업로드</vs-button>
        <input v-show="false" ref="excelInput" type="file" @change="readFile" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
        <vs-button v-if="!isPrint" color="secondary" @click="handleAddRow">항목추가</vs-button>
        <vs-button v-if="!isPrint" color="secondary" type="border" @click="handleRemoveRow">선택삭제</vs-button>
      </div>
    </div>

    <div class="w-full mt-28px" style="overflow: auto; max-height: 800px">
      <!--    head-->
      <div
        class="grid row-header border-left sticky top-0 z-10"
        style="font-weight: 700"
        :style="!isPrint ? 'grid-template-columns: 66px 70px 210px 210px 400px 180px 1000px 70px 120px 70px 120px 120px 120px 624px 400px' : 'grid-template-columns: 70px 210px 210px 400px 180px 1000px 70px 120px 70px 120px 120px 120px 624px 400px'"
      >
        <div v-if="!isPrint" class="row-header__item border-right bg-white" >
          <vs-checkbox v-model="tableAllCheck" @change="changeAllCheck"></vs-checkbox>
        </div>
        <div class="row-header__item border-right" style="background-color: #f9f9f9">No.</div>
        <div class="row-header__item border-right" style="background-color: #f9f9f9">소속</div>
        <div class="row-header__item border-right" style="background-color: #f9f9f9">작업공정<br />(담당명)</div>
        <div class="row-header__item border-right" style="background-color: #f9f9f9">물질명<br />(제품명)</div>
        <div class="row-header__item border-right" style="background-color: #f9f9f9">월 사용량</div>

        <div class="row-header__item border-right" style="background-color: #f0f0fd">
          <div class="w-full h-full" style="display: grid; grid-template-rows: 1fr 1fr; align-items: center">
            <div class="h-full border-bottom" style="display: grid; align-items: center">구성성분 및 함유량</div>
            <div class="h-full grid" style="grid-template-columns: 180px 700px 120px">
              <span class="border-right" style="display: grid; align-items: center">CAS번호</span>
              <span class="border-right" style="display: grid; align-items: center">구성성분</span>
              <span style="display: grid; align-items: center">함유량<br />(%)</span>
            </div>
          </div>
        </div>
        <div class="row-header__item border-right" style="background-color: #f0f0fd">측정대상</div>
        <div class="row-header__item border-right" style="background-color: #f0f0fd">측정주기</div>
        <div class="row-header__item border-right" style="background-color: #f0f0fd">특검대상</div>
        <div class="row-header__item border-right" style="background-color: #f0f0fd">특검주기</div>
        <div class="row-header__item border-right" style="background-color: #f0f0fd">특별관리물질</div>
        <div class="row-header__item border-right" style="background-color: #f0f0fd">관리대상물질</div>
        <div class="row-header__item border-right" style="display: grid; grid-template-rows: 1fr 1fr; background-color: #f9f9f9">
          <div class="h-full border-bottom" style="display: grid; align-items: center">관리상태</div>
          <div class="h-full grid" style="grid-template-columns: repeat(7, 70px) 140px">
            <span class="border-right" style="display: grid; align-items: center">MSDS<br />게시</span>
            <span class="border-right" style="display: grid; align-items: center">MSDS<br />관리요령<br />게시</span>
            <span class="border-right" style="display: grid; align-items: center">경고표지<br />부착</span>
            <span class="border-right" style="display: grid; align-items: center">MSDS<br />교육</span>
            <span class="border-right" style="display: grid; align-items: center">특별교육</span>
            <span class="border-right" style="display: grid; align-items: center">적정보호구 지급</span>
            <span class="border-right" style="display: grid; align-items: center">특수건강진단 실시</span>
            <span style="display: grid; align-items: center">변동사항</span>
          </div>
        </div>
        <div class="row-header__item border-right" style="background-color: #f9f9f9">비고</div>
      </div>

      <!-- rows -->
      <draggable class="w-full" :list="tableList" handle=".handle">
        <div
          class="w-full grid row-content border-left"
          :style="
            !isPrint
              ? 'grid-template-columns: 66px 70px 210px 210px 400px 180px  180px 700px 120px  70px 120px 70px 120px 120px 120px   66px 70px 70px 70px 70px 70px 70px 140px    400px'
              : 'grid-template-columns:      70px 210px 210px 400px 180px  180px 700px 120px  70px 120px 70px 120px 120px 120px 66px 70px 70px 70px 70px 70px 70px 140px 400px'
          "
          v-for="(rows, indexRows) in tableList"
          :key="indexRows"
        >
          <div v-if="!isPrint" class="none-border-center border-right border-bottom h-full">
            <feather-icon class="handle mr-4 ml-2" icon="MenuIcon" style="width: 14px; height: 14px; cursor: pointer" />
            <vs-checkbox v-model="rows.is_checked"></vs-checkbox>
          </div>

          <!-- No. -->
          <div class="item-area p-1 border-right border-bottom h-full flex justify-center">
            <span style="align-self: center">{{ indexRows + 1 }}</span>
          </div>

          <!-- 소속 -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <ml-input v-if="!isPrint" rows="1" v-model="rows.소속" class="w-full flex-1 p-1" placeholder="입력" />
            <span v-else class="print-input">{{ rows.소속 }}</span>
          </div>

          <!-- 작업공정(담당명) -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <ml-input v-if="!isPrint" rows="1" v-model="rows.작업공정" class="w-full flex-1 p-1" placeholder="입력" />
            <span v-else class="print-input">{{ rows.작업공정 }}</span>
          </div>

          <!-- 물질명(제품명) -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <ml-input v-if="!isPrint" rows="1" v-model="rows.물질명" class="w-full flex-1 p-1" placeholder="입력" />
            <span v-else class="print-input">{{ rows.물질명 }}</span>
          </div>

          <!-- 월사용량 -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <ml-input v-if="!isPrint" rows="1" v-model="rows.월사용량" class="w-full flex-1 p-1" placeholder="입력" />
            <span v-else class="print-input">{{ rows.월사용량 }}</span>
          </div>

          <!-- CAS번호 -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <ml-input v-if="!isPrint" rows="1" v-model="rows.CAS번호" class="w-full flex-1 p-1" placeholder="입력" />
            <span v-else class="print-input">{{ rows.CAS번호 }}</span>
          </div>

          <!-- 구성성분 -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <ml-input v-if="!isPrint" rows="1" v-model="rows.구성성분" class="w-full flex-1 p-1" placeholder="입력" />
            <span v-else class="print-input">{{ rows.구성성분 }}</span>
          </div>

          <!-- 함유량(%) -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <div v-if="!isPrint" class="flex-1 flex items-center">
              <ml-input rows="1" v-model="rows.함유량" class="w-full flex-1 p-1" placeholder="30~40" />
              <span class="px-1">%</span>
            </div>
            <span v-else class="print-input">{{ rows.함유량 }}%</span>
          </div>

          <!-- 측정대상 -->
          <div class="item-area p-1 border-right border-bottom h-full" style="display: grid; align-items: center; justify-content: center">
            <vs-checkbox v-if="!isPrint" v-model="rows.측정대상"></vs-checkbox>
            <span v-else class="print-input">{{ rows.측정대상 }}</span>
          </div>

          <!-- 측정주기 -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <div v-if="!isPrint" class="flex-1 flex items-center">
              <ml-input rows="1" v-model="rows.측정주기" class="w-full flex-1 p-1" placeholder="-" />
              <span class="px-1">개월</span>
            </div>
            <span v-else class="print-input">{{ rows.측정주기 }}개월</span>
          </div>

          <!-- 특검대상 -->
          <div class="item-area p-1 border-right border-bottom h-full" style="display: grid; align-items: center; justify-content: center">
            <vs-checkbox v-if="!isPrint" v-model="rows.특검대상"></vs-checkbox>
            <span v-else class="print-input">{{ rows.특검대상 }}</span>
          </div>

          <!-- 특검주기 -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <div v-if="!isPrint" class="flex-1 flex items-center">
              <ml-input rows="1" v-model="rows.특검주기" class="w-full flex-1 p-1" placeholder="-" />
              <span class="px-1">개월</span>
            </div>
            <span v-else class="print-input">{{ rows.특검주기 }}개월</span>
          </div>

          <!-- 특별관리물질 -->
          <div class="item-area p-1 border-right border-bottom h-full" style="display: grid; align-items: center; justify-content: center">
            <vs-checkbox v-if="!isPrint" v-model="rows.특별관리물질"></vs-checkbox>
            <span v-else class="print-input">{{ rows.특별관리물질 }}</span>
          </div>

          <!-- 관리대상물질 -->
          <div class="item-area p-1 border-right border-bottom h-full" style="display: grid; align-items: center; justify-content: center">
            <vs-checkbox v-if="!isPrint" v-model="rows.관리대상물질"></vs-checkbox>
            <span v-else class="print-input">{{ rows.관리대상물질 }}</span>
          </div>

          <!--  MSDS게시  -->
          <div class="item-area p-1 border-right border-bottom h-full" style="display: grid; align-items: center; justify-content: center">
            <vs-checkbox v-if="!isPrint" v-model="rows.MSDS게시"></vs-checkbox>
            <span v-else class="print-input">{{ rows.MSDS게시 }}</span>
          </div>

          <!--  MSDS관리요령게시  -->
          <div class="item-area p-1 border-right border-bottom h-full" style="display: grid; align-items: center; justify-content: center">
            <vs-checkbox v-if="!isPrint" v-model="rows.MSDS관리요령게시"></vs-checkbox>
            <span v-else class="print-input">{{ rows.MSDS관리요령게시 }}</span>
          </div>

          <!--  경고표지부착  -->
          <div class="item-area p-1 border-right border-bottom h-full" style="display: grid; align-items: center; justify-content: center">
            <vs-checkbox v-if="!isPrint" v-model="rows.경고표지부착"></vs-checkbox>
            <span v-else class="print-input">{{ rows.경고표지부착 }}</span>
          </div>

          <!--  MSDS교육  -->
          <div class="item-area p-1 border-right border-bottom h-full" style="display: grid; align-items: center; justify-content: center">
            <vs-checkbox v-if="!isPrint" v-model="rows.MSDS교육"></vs-checkbox>
            <span v-else class="print-input">{{ rows.MSDS교육 }}</span>
          </div>

          <!--  특별교육  -->
          <div class="item-area p-1 border-right border-bottom h-full" style="display: grid; align-items: center; justify-content: center">
            <vs-checkbox v-if="!isPrint" v-model="rows.특별교육"></vs-checkbox>
            <span v-else class="print-input">{{ rows.특별교육 }}</span>
          </div>

          <!--  적정보호구지급  -->
          <div class="item-area p-1 border-right border-bottom h-full" style="display: grid; align-items: center; justify-content: center">
            <vs-checkbox v-if="!isPrint" v-model="rows.적정보호구지급"></vs-checkbox>
            <span v-else class="print-input">{{ rows.적정보호구지급 }}</span>
          </div>

          <!--  특수건강진단실시  -->
          <div class="item-area p-1 border-right border-bottom h-full" style="display: grid; align-items: center; justify-content: center">
            <vs-checkbox v-if="!isPrint" v-model="rows.특수건강진단실시"></vs-checkbox>
            <span v-else class="print-input">{{ rows.특수건강진단실시 }}</span>
          </div>

          <!--  변동사항  -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <ml-input v-if="!isPrint" rows="1" v-model="rows.변동사항" class="w-full flex-1 p-1" placeholder="입력" />
            <span v-else class="print-input">{{ rows.변동사항 }}</span>
          </div>

          <!-- 비고 -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <ml-input v-if="!isPrint" rows="1" v-model="rows.비고" class="w-full flex-1 p-1" placeholder="입력" />
            <span v-else class="print-input">{{ rows.비고 }}</span>
          </div>
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import XLSX from "xlsx";

export default {
  name: "MsdsModule",
  components: {
    draggable,
  },
  props: {
    title: {
      type: String,
      default: () => "MSDS",
    },
    colTitle_1: String,
    colTitle_2: String,
    colTitle_3: String,
    colTitle_4: String,
    value: Array,
    isPrint: Boolean,
    isReadonly: Boolean,
  },
  data() {
    return {
      isOverwrite: false,
      tableAllCheck: false,
      tableList: [],
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value && value.length > 0) {
          this.tableList = value;
        }
      },
    },
    tableList(value) {
      this.$emit("input", value);
    },
  },
  methods: {
    checkForm(value, indexRows, text) {
      if (value.target.checked) {
        this.$emit("update-list-check", indexRows - 1, text);
      } else {
        this.$emit("update-list-check", indexRows - 1, "");
      }
    },
    // 항목추가
    handleAddRow() {
      this.tableList.push({
        is_checked: this.tableAllCheck,
        소속: "",
        작업공정: "",
        물질명: "",
        월사용량: "",

        CAS번호: "",
        구성성분: "",
        함유량: "",

        측정대상: "",
        측정주기: "",
        특검대상: "",
        특검주기: "",
        특별관리물질: "",
        관리대상물질: "",

        MSDS게시: "",
        MSDS관리요령게시: "",
        경고표지부착: "",
        MSDS교육: "",
        특별교육: "",
        적정보호구지급: "",
        특수건강진단실시: "",
        변동사항: "",
        비고: "",
      });
      this.updateList();
    },
    // 선택삭제
    handleRemoveRow() {
      for (let i = 0; i < this.tableList.length; i++) {
        if (this.tableList[i].is_checked) {
          this.tableList.remove(this.tableList[i]);
          i = -1;
        }
      }

      this.tableAllCheck = false;
      this.updateList();
    },
    // 일괄 체크
    changeAllCheck() {
      for (const data of this.tableList) {
        data.is_checked = this.tableAllCheck;
      }
    },
    // update
    updateList() {
      this.$emit("updateList", this.tableList);
    },
    // 데이터를 엑셀로 다운로드한다
    onClickDataDownload() {
      const tableData = this.tableList.map((data) => {
        return [
          data["소속"],
          data["작업공정"],
          data["물질명"],
          data["월사용량"],
          data["CAS번호"],
          data["구성성분"],
          data["함유량"],
          data["측정대상"] ? "Y" : "N",
          data["측정주기"],
          data["특검대상"] ? "Y" : "N",
          data["특검주기"],
          data["특별관리물질"] ? "Y" : "N",
          data["관리대상물질"] ? "Y" : "N",
          data["MSDS게시"] ? "Y" : "N",
          data["MSDS관리요령게시"] ? "Y" : "N",
          data["경고표지부착"] ? "Y" : "N",
          data["MSDS교육"] ? "Y" : "N",
          data["특별교육"] ? "Y" : "N",
          data["적정보호구지급"] ? "Y" : "N",
          data["특수건강진단실시"] ? "Y" : "N",
          data["변동사항"],
          data["비고"],
        ];
      });
      const xlsx = require("xlsx");
      // 엑셀 파일 생성
      const book = xlsx.utils.book_new();

      // data get > 실 개발시 api 호출
      const fruitDataByAoa = [
        ["[MSDS 리스트 관리] 엑셀 업로드 양식"],
        [null, null, null, null, "구성성분 및 함유량", null, null, null, null, null, null, null, null, "관리상태"],
        [
          "소속",
          "작업공정(담당명)",
          "물질명(제품명)",
          "월 사용량",
          "	CAS번호",
          "구성성분",
          "함유량(%)",
          "측정대상",
          "측정주기(개월)",
          "특검대상",
          "특검주기(개월)",
          "특별관리물질",
          "관리대상물질",
          "MSDS 게시",
          "MSDS 관리요령 게시",
          "경고표지 부착",
          "MSDS 교육",
          "특별교육",
          "적정보호구 지급",
          "특수건강진단 실시",
          "변동사항",
          "비고",
        ],
        ...tableData,
      ];

      // sheet 생성 - aoa_to_sheet 방식
      const worksheetByAoa = xlsx.utils.aoa_to_sheet(fruitDataByAoa);

      // 엑셀 파일에 sheet set(엑셀파일, 시트데이터, 시트명)
      xlsx.utils.book_append_sheet(book, worksheetByAoa, "Sheet1");

      // 엑셀 다운로드
      xlsx.writeFile(book, "MSDS 리스트 관리 데이터 수정.xlsx");
    },
    onClickExcelUpload(isOverwrite) {
      this.isOverwrite = isOverwrite;
      const excelInput = this.$refs.excelInput;
      excelInput.value = null;
      excelInput.click();
    },
    // 엑셀데이터 파싱
    readFile(event) {
      const file = event.target.files[0];

      // declare FileReader, temp result
      const reader = new FileReader();
      const tmpResult = {};

      // if you use "this", don't use "function(e) {...}"
      reader.onload = (e) => {
        let data = e.target.result;
        data = new Uint8Array(data);
        // get excel file
        const excelFile = XLSX.read(data, { type: "array", cellDates: true });

        // get prased object
        excelFile.SheetNames.forEach(function (sheetName) {
          const roa = XLSX.utils.sheet_to_json(excelFile.Sheets[sheetName], { header: 1 });
          if (roa.length) tmpResult[sheetName] = roa;
        });
        let _data = tmpResult.Sheet1.filter((data, data_i) => data_i !== 0 && 0 < data.length);
        _data = _data.slice(2);
        _data = _data.map((row) => {
          return {
            is_checked: false,
            소속: row[0],
            작업공정: row[1],
            물질명: row[2],
            월사용량: row[3],
            CAS번호: row[4],
            구성성분: row[5],
            함유량: row[6],
            측정대상: row[7] === "Y",
            측정주기: row[8],
            특검대상: row[9] === "Y",
            특검주기: row[10],
            특별관리물질: row[11] === "Y",
            관리대상물질: row[12] === "Y",
            MSDS게시: row[13] === "Y",
            MSDS관리요령게시: row[14] === "Y",
            경고표지부착: row[15] === "Y",
            MSDS교육: row[16] === "Y",
            특별교육: row[17] === "Y",
            적정보호구지급: row[18] === "Y",
            특수건강진단실시: row[19] === "Y",
            변동사항: row[20],
            비고: row[21],
          };
        });
        if (this.isOverwrite) {
          this.tableList = _data;
        } else this.tableList = [...this.tableList, ..._data];

        this.isOverwrite = false;
      };
      reader.readAsArrayBuffer(file);
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$bg: #f9f9f9;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.label-text {
  width: 127px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 25px;
}
.vs-checkbox-default {
  margin: 0;
}
.ml-group-checkBox ~ .ml-group-checkBox {
  margin: 0;
}

/* Table */
.row-header {
  text-align: center;

  &__checkbox-title {
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: $border;
    width: 100%;
  }
  &__checkboxs {
    display: flex;
    height: 50%;
    width: 100%;
    div {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    div:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
}
.row-header__item {
  border: $border;
  border-left: none;
  border-right: none;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.row-header__item.item-col {
  flex-direction: column;
}
.row-header__item:last-child {
  border-right: none;
}

.none-border-center {
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* row data */
.row-content {
  &__title {
    background-color: $bg;
    height: 100%;
  }
  &__body {
  }
}
.row-content__body-item {
  .item-content {
    padding: 15px;
    border-left: $border;

    pre {
      font-family: "Noto Sans KR", "Montserrat", Helvetica, Arial, sans-serif;
      white-space: pre-wrap;
    }
  }
  .item-box {
    border-left: $border;
    border-right: $border;
    display: flex;
    .item-box-check {
      flex: 1;
      justify-content: center !important;
    }
    .item-box-check:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
  .item-area {
    padding: 5px;
    align-self: center;
  }
}
.row-content__body-item ~ .row-content__body-item {
  border-top: $border;
}
.vs-component.vs-con-textarea.vs-textarea-primary {
  margin: 0;
}
.row-content-none-data {
  height: 120px;
  border-bottom: $border;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
